import { gql } from '@apollo/client';

export const INTAKES_FOR_SELECT = gql`
  query intakes_for_select {
    intake {
      id
      name
    }
  }
`;

export const INTAKE = gql`
  query intake {
    intake {
      name
      id
      month
    }
  }
`;
